// extracted by mini-css-extract-plugin
export default {"wrapper":"SidebarNodeslist_wrapper__wpbgM"};